import Carousel from "../../component/carousel"
import { Helmet } from "react-helmet"
import News from "../../component/news"

const IndiaAssociationCongress = ()=>{
    return(
        <>
        <Helmet>
                <meta charSet="utf-8" />
                <title>10th India Association Congress</title>
                <link rel="canonical" href="https://cimglobal.net/" />
            </Helmet>
         <Carousel
         mainText={
            `10th India Association Congress`
         }
         smallText={
            ``
         }
         images={["img/slide-01.jpg","img/slide-01.jpg","img/slide-01.jpg"]}
         />
        <div className="page-contextual page-contextual--article"  >




    <article className="article">
            <div id="top">
                
<section className="hero-article" id="5532">
<div className="content-wrapper">
        <h2 className="heading-2 hero-article__heading">10th India Association Congress</h2>

        

    <div className="media-wrapper hero-article__media link--zoom-image">
            <img className="img-cover" src="./img/10th-India-Association-Congress.jpg" alt="10th India Association Congress"/></div>
    </div>
</section>
            </div>
            <div id="">
                <section className="mod-two-cols mod-two-cols--no-padding" data-lazy-load>
<div className="content-wrapper">
   
    <div className="">
            <div>
<div id="Overview">
<div className="block-text">
{/*<h3 className="heading-3 block-text__header grid__item md--one-whole">Overview</h3>*/}
<div className="grid grid--flex">

<div className="grid__item md--one-whole ">
<p className="text--large block-text__subheader">
The 10th India Association Congress embarked on a transformative journey, exploring the theme “Association Renaissance: Rediscovering Purpose.” Held on November 17th-18th, 2023, at the Sheraton Grand Whitefield, Bengaluru, the event drew a substantial audience of decision-makers, including the President, Secretary General, Executive Directors, Chairmen, Vice Presidents, Chapter Chairs, Treasurers, and Board Members. IAC 2023 stands as a convergence of the most influential minds in the association ecosystem.
<br/><br/>
Noteworthy attendees included Hon’ble Mr. Basavaraj Bommai, Former Chief Minister of Karnataka and Member of the Karnataka Legislative Assembly, Bengaluru.
<br/><br/>
Inspired by the historical renaissance period, this congress was dedicated to empowering associations to reconnect with their intrinsic core, realign their vision, and reimagine their profound impact on society.
<br/><br/>
It was a platform that provided a unique opportunity for esteemed association leaders to congregate and engage in insightful discussions, exploring opportunities and challenges that transcended both national and international boundaries.
<br/><br/>
Website: <a href="https://indiaassociationcongress.com/" target="_blank"><b>www.indiaassociationcongress.com</b></a>

</p>

</div>
</div>
</div>
</div>

  {/* 
<div id="Facts">
<div className="block-text">
<h3 className="heading-3 block-text__header grid__item md--one-whole">Key Facts</h3>
<div className="grid grid--flex">
  

    <div className="grid__item md--one-whole">
            <p className="text--large block-text__subheader">
<ul className="block-text__labels-list">
<li>o	The 3rd International Festival of Science, Technology, Engineering & Mathematics (STEMFest) 2016 was hosted in Mysore, India, from October 17-20, 2016.</li>
<li>o	The event was organized by the Global STEM States, an international body, in association with the University of Mysore.</li>
<li>o	CIMGLOBAL, a leading professional conference management company in India, was selected as the official Professional Conference Organizer (PCO) for the STEMFest 2016 event.</li>
<li>o	The event attracted a diverse range of participants, including renowned international and national speakers, leading institutions, R&D organizations, and over 15,000 visitors for the education and technology exhibition.</li>
<li>o	The event featured a wide range of activities, including symposiums, keynote addresses, workshops, science competitions, and demonstrations of cutting-edge technologies.</li>
<li>o	CIMGLOBAL's expertise in event management, including logistics coordination, venue management, speaker and sponsor management, and on-site coordination, was instrumental in the success of the STEMFest 2016 event.</li>
<li>o	The successful hosting of the 3rd International STEMFest 2016 in Mysore showcased the city's capabilities in hosting large-scale international conferences and attracted global attention to India's prowess in science, technology, engineering, and mathematics.</li>
            </ul>
            </p>
      
    </div>
</div>
</div>


                    </div>*/}
                  
            </div>
    </div>
</div>
</section>



            </div>
           
           
    </article>
</div>
<News/>
        </>
    )
}

export default IndiaAssociationCongress